import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ProductSpecificationAttributeOptionBasicInfoComponent from "./settlement-requests-basic-info.component";
import SettlementRequestsBasicInfoComponent from "./settlement-requests-basic-info.component";
import { OrdersListComponent } from "./orders-list.component";

export const OrdersPopup = ({ 
  closeModal,
  handleSelectedOrders,
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <OrdersListComponent 
            closeModal={closeModal}
            handleSelectedOrders={handleSelectedOrders}
          />
        </Popup>
      </>
    )
  }